/**
 * Funkcje i stałe do oceny poziomu ryzyka projektowego.
 * Używane w Karcie Projektu i Sprawozdaniach.
 */
export const RISK_LEVELS = {
    ACCEPTABLE_NO_ACTION: {
        text: 'Akceptowalne - brak potrzeby reakcji',
        severity: 'success',
    },
    ACCEPTABLE_MONITOR: {
        text: 'Akceptowalne - potrzeba monitorowania',
        severity: 'warning',
    },
    UNACCEPTABLE: {
        text: 'Nieakceptowalne - konieczne podjęcie działań',
        severity: 'danger',
    },
    UNDEFINED: {
        text: 'Nieokreślone',
        severity: 'secondary',
    },
    EMPTY: {
        text: '',
        severity: 'secondary',
    },
};

export const evaluateRiskLevel = (prawdopodobienstwo, skutek) => {
    if (!prawdopodobienstwo || !skutek) {
        return RISK_LEVELS.EMPTY;
    }

    const p = prawdopodobienstwo;
    const s = skutek;

    if (
        (p === 'male' && s === 'maly') ||
        (p === 'srednie' && s === 'maly') ||
        (p === 'male' && s === 'sredni')
    ) {
        return RISK_LEVELS.ACCEPTABLE_NO_ACTION;
    }

    if (
        (p === 'srednie' && s === 'sredni') ||
        (p === 'male' && s === 'duzy') ||
        (p === 'duze' && s === 'maly')
    ) {
        return RISK_LEVELS.ACCEPTABLE_MONITOR;
    }

    if (
        (p === 'duze' && s === 'sredni') ||
        (p === 'srednie' && s === 'duzy') ||
        (p === 'duze' && s === 'duzy')
    ) {
        return RISK_LEVELS.UNACCEPTABLE;
    }

    return RISK_LEVELS.EMPTY;
};

export const getOptionLabel = (options, value) => {
    const found = options.find((o) => o.value === value);
    return found ? found.label : value || '-';
};

export const getOptionVariant = (options, value, fallback = 'secondary') => {
    const found = options.find((o) => o.value === value);
    return found?.variant || fallback;
};

export default {
    RISK_LEVELS,
    evaluateRiskLevel,
    getOptionLabel,
    getOptionVariant,
};
